import zh from './locales/zh'
import en from './locales/en'

const cache = {
  zh,
  en
}

export function hasLocale(lang) {
  return Boolean(cache[lang])
}

export async function loadLocaleMessages(lang) {
  if (cache[lang]) {
    return cache[lang]
  }
  switch (lang) {
    case 'zh':
      cache.zh = (await import(/* webpackChunkName: "locale-zh" */ './locales/zh')).default
      return cache.zh
    case 'en':
      cache.en = (await import(/* webpackChunkName: "locale-en" */ './locales/en')).default
      return cache.en
    default:
      return {}
  }
}

